import React from "react";

const AccountDeletion = () => {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1>Request Account Deletion</h1>
      <p>
        If you would like to delete your GrubSy account, please follow these steps:
      </p>
      <ol>
        <li>Log in to your account on the GrubSy app or website.</li>
        <li>Go to the <strong>Settings</strong> section.</li>
        <li>Select <strong>Delete Account</strong>.</li>
        <li>Follow the on-screen instructions to confirm your request.</li>
      </ol>
      <h2>What Happens When You Delete Your Account?</h2>
      <p>
        Upon successful account deletion, the following data will be permanently deleted:
      </p>
      <ul>
        <li>Your profile information (name, email, phone number).</li>
        <li>Order history and preferences.</li>
        <li>Any saved payment methods.</li>
      </ul>
      <p>
        <strong>Note:</strong> Certain transaction data may be retained for a limited time to comply with legal obligations.
      </p>
      <h2>Need Assistance?</h2>
      <p>
        If you encounter any issues, please contact our support team at{" "}
        <a href="mailto:support@grubsy.com">support@grubsy.com</a>.
      </p>
    </div>
  );
};

export default AccountDeletion;
